var download = "https://shopfront-cdn.tekoapis.com/static/1a12d49243365c56.svg";

export { download as default };
